// Direct purchase links for public-transport passes / travel cards, indexed
// by city name. Keys are lowercase and accent-stripped (NFD). When adding
// new cities, prefer the OFFICIAL operator page (Metro / city transport
// authority) over third-party resellers. URLs are static — no API calls,
// no AI usage, no extra credits per route generation.

const TRANSIT_BUY_URLS: Record<string, string> = {
  // ───── Portugal ─────
  "lisboa": "https://www.metrolisboa.pt/comprar/",
  "lisbon": "https://www.metrolisboa.pt/comprar/",
  "porto": "https://www.linhandante.com/tarifario.asp",
  "coimbra": "https://www.smtuc.pt/tarifario/",
  "braga": "https://www.tub.pt/tarifarios/",
  "faro": "https://www.proximo.pt/tarifario/",
  "funchal": "https://www.horariosdofunchal.pt/index.php/pt/tarifario",
  "ponta delgada": "https://www.maviauto.pt/tarifario/",

  // ───── Spain ─────
  "madrid": "https://www.crtm.es/billetes-y-tarifas/billete-turistico.aspx",
  "barcelona": "https://www.tmb.cat/en/barcelona-fares-metro-bus/single-multipersonal/hola-bcn-travel-card",
  "sevilla": "https://www.tussam.es/es/tarjetas-y-billetes",
  "seville": "https://www.tussam.es/es/tarjetas-y-billetes",
  "valencia": "https://www.metrovalencia.es/titulos-y-tarifas/",
  "granada": "https://www.transportesrober.com/es/tarjetas",
  "malaga": "https://www.emtmalaga.es/emt-malaga/tarifas/tarifas.html",
  "bilbao": "https://www.metrobilbao.eus/usa-el-metro/billetes-y-tarifas",
  "san sebastian": "https://www.dbus.eus/en/tarifas/",
  "donostia": "https://www.dbus.eus/en/tarifas/",
  "zaragoza": "https://zaragoza.avanzagrupo.com/tarifas/",
  "cordoba": "https://www.aucorsa.es/tarifas/",
  "palma": "https://www.tib.org/en/web/ctm/billets-i-tarifes",
  "palma de mallorca": "https://www.tib.org/en/web/ctm/billets-i-tarifes",

  // ───── United Kingdom & Ireland ─────
  "london": "https://contactless.tfl.gov.uk/",
  "londres": "https://contactless.tfl.gov.uk/",
  "manchester": "https://tfgm.com/tickets-and-passes/system-one-day",
  "liverpool": "https://www.merseytravel.gov.uk/tickets/",
  "birmingham": "https://www.tfwm.org.uk/plan-a-journey/tickets-and-passes/",
  "edinburgh": "https://www.lothianbuses.com/tickets/visitor-tickets/",
  "edimburgo": "https://www.lothianbuses.com/tickets/visitor-tickets/",
  "glasgow": "https://www.spt.co.uk/tickets/subway/",
  "dublin": "https://www.leapcard.ie/en/Pages/visitorleapcard.aspx",
  "belfast": "https://www.translink.co.uk/tickets",
  "cardiff": "https://www.cardiffbus.com/tickets",

  // ───── France ─────
  "paris": "https://www.iledefrance-mobilites.fr/en/tickets-fares/all-fares/navigo-easy-card",
  "lyon": "https://www.tcl.fr/titres-et-tarifs/tickets",
  "marseille": "https://www.rtm.fr/tarifs",
  "marselha": "https://www.rtm.fr/tarifs",
  "toulouse": "https://www.tisseo.fr/les-tarifs",
  "nice": "https://www.lignesdazur.com/horaires-et-trajets/tarifs",
  "bordeaux": "https://www.infotbm.com/fr/tarifs",
  "bordeus": "https://www.infotbm.com/fr/tarifs",
  "nantes": "https://www.tan.fr/fr/se-deplacer/tarifs-tickets-titres",
  "strasbourg": "https://www.cts-strasbourg.eu/en/network-cts/tickets-and-fares/",
  "estrasburgo": "https://www.cts-strasbourg.eu/en/network-cts/tickets-and-fares/",
  "lille": "https://www.ilevia.fr/cms/origine/portal-ilevia/portal/menuprincipal/tarifsetventes/touslestarifs",

  // ───── Italy ─────
  "roma": "https://www.atac.roma.it/biglietti-e-abbonamenti",
  "rome": "https://www.atac.roma.it/biglietti-e-abbonamenti",
  "milano": "https://www.atm.it/en/ViaggiaConNoi/Biglietti/Pages/default.aspx",
  "milan": "https://www.atm.it/en/ViaggiaConNoi/Biglietti/Pages/default.aspx",
  "napoli": "https://www.anm.it/index.php?option=com_content&view=article&id=192",
  "naples": "https://www.anm.it/index.php?option=com_content&view=article&id=192",
  "florenca": "https://www.at-bus.it/en/tickets-and-rates.html",
  "florence": "https://www.at-bus.it/en/tickets-and-rates.html",
  "firenze": "https://www.at-bus.it/en/tickets-and-rates.html",
  "veneza": "https://www.veneziaunica.it/en/content/transport-tickets",
  "venice": "https://www.veneziaunica.it/en/content/transport-tickets",
  "venezia": "https://www.veneziaunica.it/en/content/transport-tickets",
  "torino": "https://www.gtt.to.it/cms/tariffe-urbane",
  "turin": "https://www.gtt.to.it/cms/tariffe-urbane",
  "bologna": "https://www.tper.it/titoli-di-viaggio",
  "palermo": "https://www.amat.pa.it/biglietti-e-abbonamenti/",
  "verona": "https://www.atv.verona.it/Biglietti_e_abbonamenti",

  // ───── Germany ─────
  "berlin": "https://www.bvg.de/en/tickets-and-fares/all-tickets/welcomecard",
  "berlim": "https://www.bvg.de/en/tickets-and-fares/all-tickets/welcomecard",
  "munich": "https://www.mvv-muenchen.de/en/tickets-fares/tickets/index.html",
  "munchen": "https://www.mvv-muenchen.de/en/tickets-fares/tickets/index.html",
  "munique": "https://www.mvv-muenchen.de/en/tickets-fares/tickets/index.html",
  "hamburg": "https://www.hvv.de/en/tickets",
  "hamburgo": "https://www.hvv.de/en/tickets",
  "frankfurt": "https://www.rmv.de/c/en/start/tickets/tickets-overview",
  "cologne": "https://www.kvb.koeln/english/tickets/index.html",
  "koln": "https://www.kvb.koeln/english/tickets/index.html",
  "colonia": "https://www.kvb.koeln/english/tickets/index.html",
  "dusseldorf": "https://www.rheinbahn.de/tickets/preise",
  "stuttgart": "https://www.vvs.de/en/tickets/",
  "dresden": "https://www.dvb.de/en-gb/tickets/",
  "leipzig": "https://www.l.de/en/transport-company/tickets/season-and-day-tickets",

  // ───── Netherlands & Belgium ─────
  "amsterdam": "https://www.gvb.nl/en/travelling/travel-products-and-fares/gvb-amsterdam-travel-ticket",
  "amesterdao": "https://www.gvb.nl/en/travelling/travel-products-and-fares/gvb-amsterdam-travel-ticket",
  "rotterdam": "https://www.ret.nl/home/ov-tickets.html",
  "roterdao": "https://www.ret.nl/home/ov-tickets.html",
  "the hague": "https://www.htm.nl/en/travel-information/htm-tickets",
  "den haag": "https://www.htm.nl/en/travel-information/htm-tickets",
  "haia": "https://www.htm.nl/en/travel-information/htm-tickets",
  "utrecht": "https://www.u-ov.info/en/tickets",
  "brussels": "https://www.stib-mivb.be/article.html?l=en&_guid=cce2ad8e-29e0-3b8a-7c0d-3e2bf9447894",
  "bruxelas": "https://www.stib-mivb.be/article.html?l=en&_guid=cce2ad8e-29e0-3b8a-7c0d-3e2bf9447894",
  "bruxelles": "https://www.stib-mivb.be/article.html?l=en&_guid=cce2ad8e-29e0-3b8a-7c0d-3e2bf9447894",
  "antwerp": "https://www.delijn.be/en/vervoerbewijzen/",
  "antuerpia": "https://www.delijn.be/en/vervoerbewijzen/",
  "bruges": "https://www.delijn.be/en/vervoerbewijzen/",
  "brugge": "https://www.delijn.be/en/vervoerbewijzen/",
  "ghent": "https://www.delijn.be/en/vervoerbewijzen/",
  "gante": "https://www.delijn.be/en/vervoerbewijzen/",

  // ───── Switzerland & Austria ─────
  "zurich": "https://www.zvv.ch/zvv/en/travelcards-and-tickets/tickets.html",
  "geneva": "https://www.tpg.ch/en/tickets-fares",
  "genebra": "https://www.tpg.ch/en/tickets-fares",
  "bern": "https://www.bernmobil.ch/de/Reisende/Tickets",
  "basel": "https://www.bvb.ch/fahrplan-und-tickets/tickets",
  "wien": "https://shop.wienerlinien.at/index.php/tickets/tourist-tickets.html",
  "vienna": "https://shop.wienerlinien.at/index.php/tickets/tourist-tickets.html",
  "viena": "https://shop.wienerlinien.at/index.php/tickets/tourist-tickets.html",
  "salzburg": "https://salzburg-verkehr.at/en/tickets/",
  "innsbruck": "https://www.ivb.at/tickets/",
  "graz": "https://www.holding-graz.at/de/mobilitaet/tickets-tarife/",

  // ───── Czech Republic, Poland, Hungary ─────
  "prague": "https://www.dpp.cz/en/fares/short-term-tickets",
  "praga": "https://www.dpp.cz/en/fares/short-term-tickets",
  "brno": "https://www.dpmb.cz/en/short-term-tickets",
  "warsaw": "https://www.wtp.waw.pl/en/tickets/",
  "varsovia": "https://www.wtp.waw.pl/en/tickets/",
  "krakow": "https://www.mpk.krakow.pl/en/timetable/tariffs/",
  "cracovia": "https://www.mpk.krakow.pl/en/timetable/tariffs/",
  "gdansk": "https://ztm.gda.pl/en/tariff/",
  "wroclaw": "https://www.wroclaw.pl/en/tickets",
  "budapest": "https://bkk.hu/en/tickets-and-passes/prices/",
  "bratislava": "https://www.dpb.sk/en/tickets-fares/",

  // ───── Nordic countries ─────
  "copenhagen": "https://dinoffentligetransport.dk/en/tickets/citypass",
  "copenhaga": "https://dinoffentligetransport.dk/en/tickets/citypass",
  "stockholm": "https://sl.se/en/in-english/fares--tickets/travelcards",
  "estocolmo": "https://sl.se/en/in-english/fares--tickets/travelcards",
  "gothenburg": "https://www.vasttrafik.se/en/tickets/",
  "goteborg": "https://www.vasttrafik.se/en/tickets/",
  "malmo": "https://www.skanetrafiken.se/en/tickets-and-cards/",
  "oslo": "https://ruter.no/en/buying-tickets/tickets-and-fares/single-tickets-and-period-tickets/",
  "bergen": "https://www.skyss.no/en/tickets-and-prices/",
  "helsinki": "https://www.hsl.fi/en/tickets-and-fares/single-and-day-tickets",
  "helsinquia": "https://www.hsl.fi/en/tickets-and-fares/single-and-day-tickets",
  "reykjavik": "https://straeto.is/en/fargjold/",
  "reiquiavique": "https://straeto.is/en/fargjold/",

  // ───── Greece, Turkey, Balkans ─────
  "atenas": "https://www.athenstransport.com/english/tickets/",
  "athens": "https://www.athenstransport.com/english/tickets/",
  "tessalonica": "https://oasth.gr/en/tickets/",
  "thessaloniki": "https://oasth.gr/en/tickets/",
  "istambul": "https://www.istanbulkart.istanbul/en",
  "istanbul": "https://www.istanbulkart.istanbul/en",
  "ankara": "https://www.ego.gov.tr/tr/sayfa/12/ucret-tarifesi",
  "zagreb": "https://www.zet.hr/en/tariff/",
  "ljubljana": "https://www.lpp.si/en/urbana/where-buy-and-recharge-urbana",
  "belgrade": "https://www.busplus.rs/en/",
  "belgrado": "https://www.busplus.rs/en/",
  "sofia": "https://sofiatraffic.bg/en/tickets",
  "bucareste": "https://stbsa.ro/en/fares/",
  "bucharest": "https://stbsa.ro/en/fares/",

  // ───── North America ─────
  "new york": "https://new.mta.info/fares",
  "nova iorque": "https://new.mta.info/fares",
  "boston": "https://www.mbta.com/fares",
  "washington": "https://www.wmata.com/fares/",
  "philadelphia": "https://www.septakey.org/",
  "filadelfia": "https://www.septakey.org/",
  "chicago": "https://www.transitchicago.com/fares/",
  "miami": "https://www.miamidade.gov/global/transportation/fares.page",
  "los angeles": "https://www.metro.net/riding/fares/",
  "san francisco": "https://www.clippercard.com/ClipperWeb/",
  "sao francisco": "https://www.clippercard.com/ClipperWeb/",
  "seattle": "https://www.soundtransit.org/ride-with-us/how-to-pay",
  "portland": "https://trimet.org/fares/",
  "las vegas": "https://www.rtcsnv.com/transit/fares-passes/",
  "toronto": "https://www.prestocard.ca/en/",
  "montreal": "https://www.stm.info/en/info/fares",
  "vancouver": "https://www.translink.ca/transit-fares",
  "mexico city": "https://www.metro.cdmx.gob.mx/tarifa",
  "cidade do mexico": "https://www.metro.cdmx.gob.mx/tarifa",

  // ───── South America ─────
  "rio de janeiro": "https://www.metrorio.com.br/tarifas",
  "sao paulo": "https://www.metro.sp.gov.br/tarifa/",
  "buenos aires": "https://tarjetasube.sube.gob.ar/",
  "santiago": "https://www.tarjetabip.cl/",
  "lima": "https://www.metropolitano.com.pe/usuarios/tarifas-y-recargas/",
  "bogota": "https://www.transmilenio.gov.co/publicaciones/151538/tarjeta-tullave/",
  "medellin": "https://www.metrodemedellin.gov.co/viaje-con-nosotros/tarjeta-civica",

  // ───── Asia ─────
  "tokyo": "https://www.jreast.co.jp/multi/en/pass/tokyo_free.html",
  "toquio": "https://www.jreast.co.jp/multi/en/pass/tokyo_free.html",
  "kyoto": "https://oneday-pass.kyoto/en/",
  "quioto": "https://oneday-pass.kyoto/en/",
  "osaka": "https://subway.osakametro.co.jp/en/guide/page/enjoy-eco-card.php",
  "nagoya": "https://www.kotsu.city.nagoya.jp/en/pc/TICKET/",
  "fukuoka": "https://subway.city.fukuoka.lg.jp/eng/ticket_info/",
  "sapporo": "https://www.city.sapporo.jp/st/english/ticket.html",
  "hiroshima": "https://www.hiroshima-navi.or.jp/en/pamphlet/transportation_ticket/",
  "seoul": "https://www.seoul.go.kr/eng/visiting/transportCard.do",
  "seul": "https://www.seoul.go.kr/eng/visiting/transportCard.do",
  "busan": "https://www.humetro.busan.kr/english/main.do",
  "beijing": "https://english.beijing.gov.cn/livinginbeijing/visitors/transport/",
  "pequim": "https://english.beijing.gov.cn/livinginbeijing/visitors/transport/",
  "shanghai": "https://service.shmetro.com/en/cxfw/zwfw/zspj/index.htm",
  "xangai": "https://service.shmetro.com/en/cxfw/zwfw/zspj/index.htm",
  "hong kong": "https://www.octopus.com.hk/en/consumer/octopus-cards/tourist/index.html",
  "taipei": "https://english.metro.taipei/cp.aspx?n=BAB9512673A85F45",
  "singapore": "https://www.smrt.com.sg/Tickets-and-Fares/Tourist-Pass",
  "singapura": "https://www.smrt.com.sg/Tickets-and-Fares/Tourist-Pass",
  "bangkok": "https://www.bts.co.th/eng/customer/01rabbit_overview.html",
  "kuala lumpur": "https://www.myrapid.com.my/traveling-with-us/how-to-travel-with-us/touch-n-go/",
  "jakarta": "https://transjakarta.co.id/tarif-dan-cara-bayar/",
  "manila": "https://lrta.gov.ph/fare-matrix/",
  "ho chi minh": "https://hcmcmetro.vn/",
  "hanoi": "https://hanoimetro.com.vn/en/ticket/",
  "delhi": "https://www.delhimetrorail.com/fare",
  "mumbai": "https://mumbaimetro.com/Static.aspx?Page=12",
  "bombaim": "https://mumbaimetro.com/Static.aspx?Page=12",
  "bangalore": "https://english.bmrc.co.in/Fare",
  "dubai": "https://www.rta.ae/wps/portal/rta/ae/public-transport/nol-card",
  "abu dhabi": "https://itc.gov.ae/en/services/public-bus-fares/",
  "doha": "https://www.qrail.com.qa/en/Travel-Smart/Fares",
  "telavive": "https://www.rav-kav.co.il/en/",
  "tel aviv": "https://www.rav-kav.co.il/en/",
  "jerusalem": "https://www.rav-kav.co.il/en/",
  "jerusalem leste": "https://www.rav-kav.co.il/en/",
  "cairo": "https://www.cairometro.gov.eg/en/Fare",

  // ───── Oceania & Africa ─────
  "sydney": "https://transportnsw.info/tickets-opal",
  "sidney": "https://transportnsw.info/tickets-opal",
  "melbourne": "https://www.ptv.vic.gov.au/tickets/myki/",
  "brisbane": "https://translink.com.au/tickets-and-fares",
  "perth": "https://www.transperth.wa.gov.au/SmartRider",
  "auckland": "https://at.govt.nz/bus-train-ferry/at-hop-card/",
  "wellington": "https://www.metlink.org.nz/tickets-and-fares/snapper/",
  "cape town": "https://www.myciti.org.za/en/fares-and-products/",
  "cidade do cabo": "https://www.myciti.org.za/en/fares-and-products/",
  "joanesburgo": "https://www.gautrain.co.za/fares",
  "johannesburg": "https://www.gautrain.co.za/fares",
  "marraquexe": "https://www.alsa.ma/en/our-services/buses/marrakech",
  "marrakech": "https://www.alsa.ma/en/our-services/buses/marrakech",
  "casablanca": "https://www.casatramway.ma/en/tariffs/",
};

/**
 * Returns the official purchase URL for a city's transit pass / travel card,
 * or null when no curated link exists.
 */
export function getTransitPassUrl(city: string): string | null {
  const key = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
  return TRANSIT_BUY_URLS[key] ?? null;
}
